export default {
  data() {
    return {
      billingEntities: [],
      billingEntitiesLoading: false,
      selectedBillingEntityId: null,
    }
  },

  computed: {
    selectedBillingCountryCode() {
      const countries = this.authCountries || []
      const selectedCountry = countries.find(country => country.value === this.$store.state.countryId)

      return selectedCountry && selectedCountry.iso2 ? selectedCountry.iso2.toUpperCase() : null
    },

    countryBillingEntities() {
      return this.billingEntities.filter(entity => (
        !this.selectedBillingCountryCode || entity.country_code === this.selectedBillingCountryCode
      ))
    },

    billingEntityFilterOptions() {
      return [{ value: null, label: 'All entities (combined)' }].concat(
        this.countryBillingEntities.map(entity => ({
          value: entity.id,
          label: `${entity.code} — ${entity.legal_name} (${entity.status})`,
        }))
      )
    },
  },

  watch: {
    async '$store.state.countryId'() {
      await this.loadBillingEntityFilter()
      this.handleBillingEntityFilterChange()
    },
  },

  methods: {
    async loadBillingEntityFilter() {
      this.billingEntitiesLoading = true

      try {
        const { data } = await this.$axios.get(this.$backend.BILLING_ENTITIES.OPTIONS)
        this.billingEntities = data
        this.selectDefaultBillingEntity()
      } finally {
        this.billingEntitiesLoading = false
      }
    },

    selectDefaultBillingEntity() {
      const activeEntity = this.countryBillingEntities.find(entity => (
        entity.status === 'active' && entity.is_enabled
      ))
      const fallbackEntity = this.countryBillingEntities.find(entity => entity.is_enabled)
      const selectedEntity = activeEntity || fallbackEntity

      this.selectedBillingEntityId = selectedEntity ? selectedEntity.id : null
    },

    billingEntityRequestParams() {
      return {
        billing_entity_id: this.selectedBillingEntityId,
        billing_entity_country_code: this.selectedBillingCountryCode,
      }
    },

    handleBillingEntityFilterChange() {},
  },
}
